import { useEffect, useState } from 'react';
import { toast } from '../lib/toast.js';

// Renders toasts from src/lib/toast.js. Mounted once, at the root.
const TONE = {
  info:    { bar: 'var(--gold, #b48a47)', label: '' },
  success: { bar: 'var(--success, #2D7A3A)', label: '' },
  error:   { bar: 'var(--danger, #DC2626)', label: 'Error' },
};

export function ToastHost() {
  const [items, setItems] = useState([]);
  useEffect(() => toast.subscribe(setItems), []);
  if (!items.length) return null;
  return (
    <div aria-live="polite" style={{ position: 'fixed', left: 0, right: 0, bottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',
      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, padding: '0 16px', zIndex: 10000, pointerEvents: 'none' }}>
      {items.map((t) => {
        const tone = TONE[t.kind] || TONE.info;
        return (
          <div key={t.id} role={t.kind === 'error' ? 'alert' : 'status'}
            style={{ pointerEvents: 'auto', width: '100%', maxWidth: 520, background: '#fff', color: 'var(--ink, #1f2a44)',
              borderRadius: 10, borderLeft: `4px solid ${tone.bar}`, boxShadow: '0 6px 24px rgba(31,42,68,0.18)',
              padding: '10px 12px', display: 'flex', gap: 10, alignItems: 'flex-start', fontSize: 14, lineHeight: 1.45 }}>
            <div style={{ flex: 1, minWidth: 0, whiteSpace: 'pre-line', wordBreak: 'break-word', maxHeight: '40vh', overflowY: 'auto' }}>
              {tone.label && <strong style={{ color: tone.bar, marginRight: 6 }}>{tone.label}:</strong>}{t.text}
            </div>
            <button type="button" onClick={() => toast.dismiss(t.id)} aria-label="Dismiss"
              style={{ border: 0, background: 'transparent', color: 'var(--ink-soft, #2d3a5e)', fontSize: 18, lineHeight: 1, cursor: 'pointer', padding: 2 }}>×</button>
          </div>
        );
      })}
    </div>
  );
}
